import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./assets/fonts/Daikon-Regular.ttf";

// home pages

const Home = lazy(() => import("./pages/home/Home"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));
const ShopGridFilter = lazy(() => import("./pages/shop/ShopGridFilter"));
const ShopGridTwoColumn = lazy(() => import("./pages/shop/ShopGridTwoColumn"));
const ShopGridNoSidebar = lazy(() => import("./pages/shop/ShopGridNoSidebar"));
const ShopGridFullWidth = lazy(() => import("./pages/shop/ShopGridFullWidth"));
const ShopGridRightSidebar = lazy(() =>
  import("./pages/shop/ShopGridRightSidebar")
);
const ShopListStandard = lazy(() => import("./pages/shop/ShopListStandard"));
const ShopListFullWidth = lazy(() => import("./pages/shop/ShopListFullWidth"));
const ShopListTwoColumn = lazy(() => import("./pages/shop/ShopListTwoColumn"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));
const ProductTabLeft = lazy(() =>
  import("./pages/shop-product/ProductTabLeft")
);
const ProductTabRight = lazy(() =>
  import("./pages/shop-product/ProductTabRight")
);
const ProductSticky = lazy(() => import("./pages/shop-product/ProductSticky"));
const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));
const ProductFixedImage = lazy(() =>
  import("./pages/shop-product/ProductFixedImage")
);

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));
const Login = lazy(() => import("./pages/other/Login"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
const AccountProfile = lazy(() => import("./pages/my-account/AccountProfile"));
const ContactSupport = lazy(() => import("./pages/my-account/ContactSupport"));
const MyOrders = lazy(() => import("./pages/my-account/MyOrders"));
const MyOrderDetail = lazy(() => import("./pages/my-account/MyOrderDetail"));
const Review = lazy(() => import("./pages/my-account/Review"));
const ShopGridAllProduct = lazy(() =>
  import("./pages/shop/ShopGridAllProduct")
);
const RaiseTicket = lazy(() => import("./pages/my-account/RaiseTicket"));
const Sell = lazy(() => import("./pages/sell/Sell"));
const AllCategory = lazy(() => import("./pages/sell/AllCategory"));
const OrdersSell = lazy(() => import("./pages/my-account/OrdersSell"));
const ViewOrderSell = lazy(() => import("./pages/my-account/ViewOrderSell"));
const CategoriesRent = lazy(() => import("./pages/sell/CategoriesRent"));
const ReturnPage = lazy(() => import("./pages/my-account/ReturnPage"));
const ForgotPassword = lazy(() => import("./pages/other/ForgotPassword"));
const ServiceRequest = lazy(() =>
  import("./pages/maintainence/ServiceRequest")
);
const ServiceForm = lazy(() => import("./pages/maintainence/ServiceForm"));
const AllServiceRequests = lazy(() =>
  import("./pages/maintainence/AllServiceRequests")
);
const RefundPolicy = lazy(() => import("./pages/other/RefundPolicy"));
const Terms = lazy(() => import("./pages/other/Terms"));
const PrivacyPolicy = lazy(() => import("./pages/other/PrivacyPolicy"));
const BlogPage = lazy(() => import("./pages/home/BlogPage"));
const Blogs = lazy(() => import("./pages/blogs/Blogs"));
const NewShopGridStandard = lazy(() =>
  import("./pages/shop/NewShopGridStandard")
);
const CollectionShopGridStandard = lazy(() =>
  import("./pages/shop/CollectionShopGridStandard")
);
const GuestCheckout = lazy(() => import("./pages/other/GuestCheckout"));
const OrderSuccess = lazy(() => import("./pages/other/OrderSuccess"));
const OrderFailure = lazy(() => import("./pages/other/OrderFailure"));
const PopupForm = lazy(() => import("./pages/home/PopupForm"));

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <Suspense
        // fallback={
        //   <div className="flone-preloader-wrapper">
        //     <div className="flone-preloader">
        //       <span></span>
        //       <span></span>
        //     </div>
        //   </div>
        // }
        >
          <Routes>
            <Route path={process.env.PUBLIC_URL + "/"} element={<Home />} />

            {/* Shop pages */}

            <Route
              path={process.env.PUBLIC_URL + "/shop-store/:catergory"}
              element={<ShopGridStandard />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/shops-store/:catgeory"}
              element={<NewShopGridStandard />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/shop-stores"}
              element={<CollectionShopGridStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-stores/:categoryslug"}
              element={<CollectionShopGridStandard />}
            />

            {/* <Route
              path={process.env.PUBLIC_URL + "/product/:model/:id"}
              element={<Product />}
            /> */}
            <Route
              path={process.env.PUBLIC_URL + "/shop-store/:model/:id"}
              element={<Product />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-store/:category/:model/:id"}
              element={<Product />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-filter"}
              element={<ShopGridFilter />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-two-column"}
              element={<ShopGridTwoColumn />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-no-sidebar"}
              element={<ShopGridNoSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-full-width"}
              element={<ShopGridFullWidth />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-right-sidebar"}
              element={<ShopGridRightSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-list-standard"}
              element={<ShopListStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-list-full-width"}
              element={<ShopListFullWidth />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-list-two-column"}
              element={<ShopListTwoColumn />}
            />

            {/* Shop product pages */}
            {/* <Route
              path={process.env.PUBLIC_URL + "/product/:model"}
              element={<Product />}
            /> */}

            <Route
              path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
              element={<ProductTabLeft />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
              element={<ProductTabRight />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-sticky/:id"}
              element={<ProductSticky />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-slider/:id"}
              element={<ProductSlider />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
              element={<ProductFixedImage />}
            />

            {/* Blog pages */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-standard"}
              element={<BlogStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
              element={<BlogNoSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
              element={<BlogRightSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-details-standard"}
              element={<BlogDetailsStandard />}
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/my-account"}
              element={<MyAccount />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login"}
              element={<Login />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<Checkout />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/account-profile"}
              element={<AccountProfile />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact-support"}
              element={<ContactSupport />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/orders"}
              element={<MyOrders />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/order-detail"}
              element={<MyOrderDetail />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/review"}
              element={<Review />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shopGridAllProduct"}
              element={<ShopGridAllProduct />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/raiseTicket"}
              element={<RaiseTicket />}
            />
            <Route path={process.env.PUBLIC_URL + "/sell"} element={<Sell />} />
            <Route
              path={process.env.PUBLIC_URL + "/allCategory"}
              element={<AllCategory />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/orders-sell-renton"}
              element={<OrdersSell />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/viewOrderSell"}
              element={<ViewOrderSell />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/CategoriesRent"}
              element={<CategoriesRent />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/ReturnPage"}
              element={<ReturnPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/ForgotPassword"}
              element={<ForgotPassword />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/ServiceRequest"}
              element={<ServiceRequest />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/ServiceForm"}
              element={<ServiceForm />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/AllServiceRequests"}
              element={<AllServiceRequests />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/Refund_policy"}
              element={<RefundPolicy />}
            />
            {/* <Route
              path={process.env.PUBLIC_URL + "/blog-page/:title"}
              element={<BlogPage />}
            /> */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-page/:title/:id"}
              element={<BlogPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/Blogs"}
              element={<Blogs />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/guest-checkout"}
              element={<GuestCheckout />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/terms"}
              element={<Terms />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/privacy_policy"}
              element={<PrivacyPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/order-success"}
              element={<OrderSuccess />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/order-failure"}
              element={<OrderFailure />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/model-opportunities"}
              element={<PopupForm/>}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
